import { render } from "./TermsAcceptance.vue?vue&type=template&id=0a65fa48"
import script from "./TermsAcceptance.vue?vue&type=script&lang=js"
export * from "./TermsAcceptance.vue?vue&type=script&lang=js"

import "./TermsAcceptance.vue?vue&type=style&index=0&id=0a65fa48&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__